import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { JobType } from "../../models";
import { RQ } from "../../globals/enums";
import { remove } from "../../api/generic-api";
import { deleteEntity } from "../../utils";

export const useDeleteJobType = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation((id: string) => remove("job-types", id), {
    onSuccess: (_, id) => {
      enqueueSnackbar("Job Type Deleted", { variant: "success" });
      queryClient.setQueryData(
        RQ.JOB_TYPES,
        (jobTypes: JobType[] | undefined) => {
          return !jobTypes ? [] : deleteEntity<JobType>(jobTypes, "id", id);
        }
      );
    },
    onError: () => {
      enqueueSnackbar("Job Type Deleting Error", { variant: "error" });
    },
  });
};
